

import React, { memo } from 'react';
import cx from 'classnames';
import uuid from 'uuid';
import { CONTAINER, INNER_BAR, BLOCK_STAGE, BLOCK_CONTAINER } from '../styles/progressBar';








/**
 * A progress bar component that highlights a percentage of an outer bar
 *
 * @param {number} currentStage
 * @param {number} maxStage
 *
 * @return {React.Element}
 */

function ProgressBar(props) {
  const { currentStage, maxStage, isV2Design, progressBarPosition } = props;
  if (isV2Design) {
    return (
      <div className={cx(BLOCK_CONTAINER(progressBarPosition || 'right'), 'wizard__progress-block-container')}>
        {Array.from({ length: maxStage }).map((_, index) =>
        <div
          key={uuid()}
          className={cx(BLOCK_STAGE(index < currentStage), 'wizard__progress-bar__block')} />

        )}
      </div>);

  }
  const percent = currentStage / maxStage * 100;
  return (
    <div className={cx(CONTAINER, 'wizard__progress-bar')}>
      <div className={cx(INNER_BAR(percent), 'wizard__progress-bar__progress')} />
    </div>);

}
export default memo(ProgressBar);